import { Button, Checkbox, Dialog, DialogActions, IconButton, MenuItem, Stack, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ModalHeader from '../../../../components/ModalHeader';
import { Formik, Form, FieldArray } from 'formik';
import { useTheme } from '@emotion/react';
import { useDispatch, useSelector } from 'react-redux';
import { useRef } from 'react';
import * as yup from 'yup';
import FormTextField from '../../../../components/FormTextField';
import FormSelectField from '../../../../components/FormSelectField';
import { buttonStyle2, dialogButtonCancel } from '../../../../utils/commonStyle';
import { setLoading } from '../../../../redux/features/appSlice';
import { showmessage } from '../../../../utils/toastr';
import appapi from '../../../../api/apiClient';
import { CancelToken } from 'apisauce';
import FormTextFieldLabel from '../../../../components/FormTextFieldLabel';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';
import EventIcon from '@mui/icons-material/Event';
import ClearIcon from '@mui/icons-material/Clear';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import FuelTypeDropdown from './FuelTypeDropdown';
import PortDropDown from '../../../../components/PortDropDown';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

const validationSchema = yup.object({
  voyageNo: yup.string('Voyage Id').required(' ').min(1, 'IMO Number should be atleast 3 characters').max(30, 'Maximum character Limit of IMO Number is 30').required(' '),
  fromDate: yup.string('From Date').required(' '),
  toDate: yup.string('To date').required(' '),
  voyageFromId: yup
    .object()
    .shape({
      _id: yup.string().required(' '),
    })
    .nullable()
    .required(' '),
  voyageToId: yup
    .object()
    .shape({
      _id: yup.string().required(' '),
    })
    .nullable()
    .required(' '),
  imoNumber: yup.string('IMO Number').required(' '),
  shipType: yup.string('Ship Type').required(' '),
  shipId: yup.string('Ship Id').required(' '),
  ownerId: yup.string('Owner').required(' '),
  shipCondition: yup.string('Ship Comdition').required(' '),
  summerDeadWeight: yup.string('Summer Dead Weight').required(' '),
  fuelUsed: yup
    .array()
    .of(
      yup.object().shape({
        estFuelConsumption: yup.number().required(),
      }),
    )
    .min(1)
    .required(),
});

const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '560px',
    height: '100%',
    borderRadius: '4px',
    maxWidth: '736px',
    maxHeight: 'calc(100%)',
    // overflow: 'hidden'
  },
};

const shipCondition = [
  {
    id: 1,
    name: 'laden',
  },
  {
    id: 2,
    name: 'ballast',
  },
  {
    id: 3,
    name: 'partladen',
  },
];

export default function AddVoyage({ modelOpen, onModelHandleClose, partyInfo, ship, type, details }) {
  const formRef = useRef();
  const theme = useTheme();
  const dispatch = useDispatch();

  let source = CancelToken.source();
  let ownerSource = CancelToken.source();
  let portSource = CancelToken.source();
  let priceSource = CancelToken.source();

  const [shipsList, setShipsList] = useState([]);
  const [portList, setPortList] = useState([]);
  const [spotPrice, setSpotPrice] = useState(0);

  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  const { shiptypes, shipOwners } = useSelector((state) => state.layout);

  const { userId, companyDetails } = useSelector((state) => state.auth);

  const {t} = useTranslation()

  const handleGetShips = async (fromSearch = true) => {
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `/fleet/allShip`,
      {
        pageNumber: 1,
        pageSize: 50,
        companyId: companyDetails._id,
      },
      { cancelToken: source.token },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        let shipData = data?.response.response;
        setShipsList(shipData);
      } else {
        setShipsList([]);
      }
    } else {
      setShipsList([]);
    }
  };

  const getPorts = async () => {
    portSource.cancel();
    portSource = CancelToken.source();
    const response = await appapi.get(`common/ports`, {
      pageNumber: 1,
      pageSize: 100,
    });
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setPortList(data.response || []);
      } else {
        setPortList([]);
      }
    }
  };

  const getEuaPrice = async () => {
    priceSource.cancel();
    priceSource = CancelToken.source();
    const response = await appapi.get(`common/euaFuelPrice`);
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setSpotPrice(parseFloat(data.response));
      } else {
        // setPortList([]);
      }
    }
  };

  const initApi = async () => {
    await handleGetShips();
    await getEuaPrice();
  };

  useEffect(() => {
    initApi();
    return () => {
      if (source) {
        source.cancel();
      }
      if (ownerSource) {
        ownerSource.cancel();
      }
      if (portSource) {
        portSource.cancel();
      }
    };
  }, []);

  const handleAddVoyage = async (values) => {
    dispatch(setLoading(true));
    const payload = {
      ...values,
      voyageFrom: values?.voyageFromId?.portName,
      voyageFromId: values?.voyageFromId?._id,
      voyageFromCountry: values?.voyageFromId?.country,
      voyageTo: values?.voyageToId?.portName,
      voyageToId: values?.voyageToId?._id,
      voyageToCountry: values?.voyageToId?.country,    
      summerDeadWeight: parseFloat(values?.summerDeadWeight),
      fuelUsed: values?.fuelUsed?.map((item, index) => ({
        fuelType: item?.fuelType,
        emissionFactor: parseFloat(item?.emissionFactor),
        estEuaCost: parseFloat(item?.estFuelConsumption || 0) * item?.emissionFactor * spotPrice,
        estFuelConsumption: parseFloat(item?.estFuelConsumption || 0),
        dailyConsumptionCperPLaden: parseFloat(item?.dailyConsumptionCperPLaden || 0),
        dailyConsumptionCperPBallest: parseFloat(item?.dailyConsumptionCperPBallest || 0),
      })),
    };

    const response = await appapi.post(`/fleet/voyage`, payload);
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        onModelHandleClose(true);
        showmessage(data.message);
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  const handleEditVoyage = async (values) => {
    dispatch(setLoading(true));
    const payload = {
      ...values,
      voyageFrom: values?.voyageFromId?.portName ? values?.voyageFromId?.portName : details?.voyageFrom,
      voyageFromId: values?.voyageFromId?._id ? values?.voyageFromId?._id : details?.voyageFromId,
      voyageFromCountry: values?.voyageFromId?.country ? values?.voyageFromId?.country : details?.voyageFromCountry,
      voyageTo: values?.voyageToId?.portName ? values?.voyageToId?.portName : details?.voyageTo,
      voyageToId: values?.voyageToId?._id ? values?.voyageToId?._id : details?.voyageToId,
      voyageToCountry: values?.voyageToId?.country ? values?.voyageToId?.country : details?.voyageToCountry,
      summerDeadWeight: parseFloat(values?.summerDeadWeight),
      fuelUsed: values?.fuelUsed?.map((item, index) => ({
        fuelType: item?.fuelType,
        emissionFactor: parseFloat(item?.emissionFactor),
        estEuaCost: parseFloat(item?.estFuelConsumption || 0) * item?.emissionFactor * spotPrice,
        estFuelConsumption: parseFloat(item?.estFuelConsumption || 0),
        dailyConsumptionCperPLaden: parseFloat(item?.dailyConsumptionCperPLaden || 0),
        dailyConsumptionCperPBallest: parseFloat(item?.dailyConsumptionCperPBallest || 0),
      })),
    };

    const response = await appapi.put(`/fleet/voyage/${details?._id}`, payload);
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        onModelHandleClose(true);
        showmessage(data.message);
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  const getTotal = (fuel) => {
    let total = 0;
    for (const f of fuel) {
      total = total + parseFloat(f?.estFuelConsumption || 0) * f?.emissionFactor * spotPrice;
    }
    return total.toFixed(2);
  };


  return (
    <Dialog
      sx={sx}
      open={modelOpen}
      PaperProps={{ sx: { position: 'fixed', top: 0, right: 0, m: 0 } }}
    >
      <Stack
        // className="!h-[100%]"
        style={{ backgroundColor: '#FFFFFF' }}
      >
        <ModalHeader
          label={ type === 'edit' ?  t('EDIT VOYAGE'):  t('Add voyage')}
          onClose={() => onModelHandleClose(false)}
        />
        <Stack
          style={{ backgroundColor: '#8993AC26', width: '100%', height: '2px' }}
          className=""
        />
        <Formik
          innerRef={formRef}
          enableReinitialize={false}
          initialValues={{
            voyageNo: details?.voyageNo ? details?.voyageNo : '',
            fromDate: details?.fromDate ? dayjs(new Date(details?.fromDate)) : undefined,
            toDate: details?.toDate ? dayjs(new Date(details?.toDate)) : undefined,
            voyageFromId: details?.voyageFromId ? {
              portName: details?.voyageFrom,
              _id: details?.voyageFromId,
              country: details?.voyageFromCountry
            } : undefined,
           
            voyageToId: details?.voyageToId ? {
              portName:details?.voyageTo,
              _id: details?.voyageToId,
              country: details?.voyageToCountry
            } : undefined,
            imoNumber: ship?.imoNumber || details?.imoNumber,
            shipType: ship?.shipType || details?.shipType,
            shipId: ship?._id || details?.shipId,
            shipName: details?.shipName || ship?.shipName,
            owner: partyInfo?.companyType === 'ship owner' ? partyInfo?.companyName : ship?.owner || details?.owner,
            ownerId: partyInfo?.companyType === 'ship owner' ? partyInfo?._id : ship?.ownerId || details?.ownerId,
            shipCondition: details?.shipCondition ? details?.shipCondition : '',
            summerDeadWeight: details?.summerDeadWeight || ship?.summerDeadWeight,
            fuelUsed: ship?.fuelType || details?.fuelUsed || [],
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            if(type === 'edit') {
              handleEditVoyage(values);
            }
            else {
              handleAddVoyage(values)
            }
          
          }}
        >
          {({ name, values, touched, errors, handleChange, handleBlur, isValid, dirty, setFieldValue }) => (
            <Form autoComplete="off">
              <Stack className="mt-[12px] !px-[16px]">
                <Stack className="mt-[16px]">
                  <FormTextField
                    outlineLabel={t('Voyage no.')}
                    name="voyageNo"
                    requiredMark={true}
                    // onlyAlpha={true}
                    whiteSpace={true}
                    inputProps={{ maxLength: 31 }}
                  />
                </Stack>
              </Stack>
              <Stack
                style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
                className="mx-[15px] p-[16px]"
              >
                <Typography
                  className="fw-regular ff-Roboto fs-16"
                  color={text}
                >
                  {t('Voyage details')}
                </Typography>
                <Typography
                  className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                  color={textLight}
                >
                  {t('Some info may be visible to other people using ZeroEmission services')}
                </Typography>
                <Stack
                  direction={'row'}
                  className="mt-[16px] mb-[20px] !h-[64px]"
                >
                  <Stack
                    flex={0.5}
                    height={'100px'}
                  >
                    <PortDropDown
                      selectedId={values.voyageToId?._id}
                      lable={t('Voyage from') + " *"}
                      name="voyageFromId"
                    />
                  </Stack>

                  <Stack flex={0.5}>
                    <PortDropDown
                      selectedId={values.voyageFromId?._id}
                      lable={t('Voyage to') + " *"}
                      name="voyageToId"
                    />
                  </Stack>
                  <Stack style={{ backgroundColor: '#FFFFFF', width: '28px', height: '28px', borderRadius: '16px', position: 'absolute', marginLeft: '42%', marginTop: '2.5%', borderWidth: '1px', borderColor: '#00000029', alignItems: 'center', justifyContent: 'center' }}>
                    <IconButton>
                      <CompareArrowsIcon style={{ color: '#00A632' }} />
                    </IconButton>
                  </Stack>
                </Stack>
                <Stack
                  direction={'row'}
                  className="mt-[16px] mb-[20px] !h-[64px]"
                >
                  <Stack
                    className="autocomplete-dropdown mr-[10px]"
                    flex={0.5}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        onChange={(value) => {
                          //   getOrderDate(value);
                          setFieldValue('fromDate', value);
                        }}
                        // disabled={noProductText === 'No Product Available for this Customer' ? true : false}
                        value={values?.fromDate}
                        components={{
                          OpenPickerIcon: EventIcon,
                        }}
                        inputFormat="DD-MMM-YYYY"
                        label={t('Start date') + ' *'}
                        // minDate={type === 'edit' ? dayjs(new Date(details?.fromDate)) : dayjs(new Date())}
                        renderInput={(params) => (
                          <TextField
                            id="from-date"
                            name="fromDate"
                            onKeyDown={(event) => {
                              event.preventDefault();
                            }}
                            {...params}
                            sx={{
                              // minwidth: '228px',
                              // maxWidth: '228px',
                              '& .MuiOutlinedInput-root': {
                                height: '55px',
                                bottom: '7px',
                                '& input::placeholder': {},
                              },
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </Stack>
                  <Stack
                    className="autocomplete-dropdown"
                    flex={0.5}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        onChange={(value) => {
                          //   getOrderDate(value);
                          setFieldValue('toDate', value);
                        }}
                        // disabled={noProductText === 'No Product Available for this Customer' ? true : false}
                        value={values.toDate}
                        components={{
                          OpenPickerIcon: EventIcon,
                        }}
                        minDate={values?.fromDate ? values.fromDate : moment()}
                        inputFormat="DD-MMM-YYYY"
                        label={t('End date') + ' *'}
                        renderInput={(params) => (
                          <TextField
                            id="to-date"
                            name="toDate"
                            onKeyDown={(event) => {
                              event.preventDefault();
                            }}
                            {...params}
                            sx={{
                              // minwidth: '228px',
                              // maxWidth: '228px',
                              '& .MuiOutlinedInput-root': {
                                height: '55px',
                                bottom: '7px',
                                '& input::placeholder': {},
                              },
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </Stack>
                </Stack>
              </Stack>

              <Stack
                style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
                className="mx-[15px] p-[16px] mt-[16px]"
              >
                <Typography
                  className="fw-regular ff-Roboto fs-16"
                  color={text}
                >
                  {t('Ship Information')}
                </Typography>
                <Typography
                  className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                  color={textLight}
                >
                   {t('Some info may be visible to other people using ZeroEmission services')}
                </Typography>
                <Stack>
                  <FormTextField
                    outlineLabel={t('IMO no')}
                    name="imoNumber"
                    requiredMark={true}
                    onlyNumber={true}
                    whiteSpace={true}
                    inputProps={{ maxLength: 101 }}
                    disabled={true}
                  />
                </Stack>
                <Stack>
                  <FormSelectField
                    disabled={true}
                    name="shipId"
                    label={t('Ship name') +' *'}
                    onSelect={(id) => {
                      const name = shipsList.filter((res) => res._id == id)[0]?.shipName;
                      setFieldValue('shipName', name || '');
                    }}
                  >
                    {shipsList?.length === 0 && (
                      <MenuItem
                        disabled
                        value=""
                      >
                        <em>{t('No Data Found')}</em>
                      </MenuItem>
                    )}
                    {shipsList?.map((item) => (
                      <MenuItem
                        key={item._id}
                        value={item._id}
                      >
                        <div style={{ textTransform: 'capitalize' }}>{item.shipName}</div>
                      </MenuItem>
                    ))}
                  </FormSelectField>
                </Stack>
                <Stack>
                  <FormSelectField
                    name="shipType"
                    label={t('Ship type') + ' *'}
                    disabled={true}
                  >
                    {shiptypes?.length === 0 && (
                      <MenuItem
                        disabled
                        value=""
                      >
                        <em>{t('No Data Found')}</em>
                      </MenuItem>
                    )}
                    {shiptypes?.map((item) => (
                      <MenuItem
                        key={item.shipType}
                        value={item.shipType}
                      >
                        <div style={{ textTransform: 'capitalize' }}>{item.shipType}</div>
                      </MenuItem>
                    ))}
                  </FormSelectField>
                </Stack>
                <Stack>
                  <FormTextField
                    name="owner"
                    outlineLabel={t('Ship owner')}
                    requiredMark={true}
                    disabled={true}
                  />
                </Stack>
                <Stack>
                  <FormSelectField
                    name="shipCondition"
                    label={t('Ship condition') + ' *'}
                  >
                    {shipCondition?.length === 0 && (
                      <MenuItem
                        disabled
                        value=""
                      >
                        <em>{t('No Data Found')}</em>
                      </MenuItem>
                    )}
                    {shipCondition?.map((item) => (
                      <MenuItem
                        key={item.name}
                        value={item.name}
                      >
                        <div style={{ textTransform: 'capitalize' }}>{item.name}</div>
                      </MenuItem>
                    ))}
                  </FormSelectField>
                </Stack>
                <Stack>
                  <FormTextField
                    outlineLabel={t('Summer deadweight')}
                    name="summerDeadWeight"
                    requiredMark={true}
                    onlyFloat={true}
                    whiteSpace={true}
                    inputProps={{ maxLength: 51 }}
                  />
                </Stack>
              </Stack>
              <Stack
                style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
                className="m-[15px] p-[16px]"
              >
                {' '}
                <Typography
                  className="fw-regular ff-Roboto fs-16 !capitalize"
                  color={text}
                >
                  {t('EUA information')}
                </Typography>
                <Typography
                  className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                  color={textLight}
                >
                  {t('Some info may be visible to other people using ZeroEmission services')}
                </Typography>
                <Stack>
                  {/* <FormSelectField
                    name="fuel"
                    label={'Fuel Used *'}
                    multiple
                  >
                    {fuelList?.length === 0 && (
                      <MenuItem
                        disabled
                        value=""
                      >
                        <em>No Data Found</em>
                      </MenuItem>
                    )}
                    {fuelList?.map((item) => (
                      <MenuItem
                        key={item.fuelType}
                        value={item.fuelType}
                      >
                        <div style={{ textTransform: 'capitalize' }}>{item.fuelType}</div>
                      </MenuItem>
                    ))}
                  </FormSelectField> */}
                  <FuelTypeDropdown
                    onDone={(fuelUsed) => {
                      const arr = fuelUsed.map(res => {
                        const already = values?.fuelUsed?.find( f => f.fuelType === res.fuelType); 
                        if(already) {
                          return already;
                        }
                        return res;
                      });
                      setFieldValue('fuelUsed', arr);
                    }}
                    slectedTypes={values?.fuelUsed?.map((res) => res.fuelType)}
                  />
                </Stack>
                <FieldArray
                  name="fuelUsed"
                  render={(arrayHelpers) => (
                    <>
                      {values?.fuelUsed?.map((data, index) => (
                        <Stack
                          key={index}
                          className="flex"
                          style={{ rowGap: 'initial' }}
                        >
                          <Stack
                            direction={'row'}
                            // alignItems={'center'}
                            justifyContent={'space-between'}
                          >
                            <Stack>
                              <Typography
                                className="fw-medium ff-Roboto fs-14"
                                color={text}
                              >
                                {data?.fuelType}
                              </Typography>
                              <Typography
                                className="fw-regular ff-Roboto fs-12"
                                color={text}
                              >
                                {t('Emission factor')} {data?.emissionFactor} t CO2/ t fuel
                              </Typography>
                            </Stack>
                            <Stack direction={'row'}>
                              <IconButton
                                className="!mx-[20px] !mb-[10px]"
                                onClick={() => {
                                  arrayHelpers.remove(index);
                                }}
                              >
                                <ClearIcon style={{ transform: 'scale(1)', color: '#14285A' }} />
                              </IconButton>
                            </Stack>
                          </Stack>
                          <Stack
                            direction={'row'}
                            justifyContent={'space-between'}
                          >
                            <Stack flex={1}>
                              <FormTextField
                                sx={{ mt: 0 }}
                                name={`fuelUsed[${index}].dailyConsumptionCperPLaden`}
                                outlineLabel={t('Daily consumption C/P Laden') + ' *'}
                                onlyFloat={true}
                              />
                            </Stack>
                            <Stack sx={{ width: '16px' }} />
                            <Stack flex={1}>
                              <FormTextField
                                sx={{ mt: 0 }}
                                name={`fuelUsed[${index}].dailyConsumptionCperPBallest`}
                                outlineLabel={t('Daily consumption C/P Ballast') + ' *'}
                                onlyFloat={true}
                              />
                            </Stack>
                          </Stack>
                          <Stack direction={'row'}>
                            <Stack flex={1}>
                              <FormTextField
                                sx={{ mt: 0 }}
                                name={`fuelUsed[${index}].estFuelConsumption`}
                                outlineLabel={t('Estimated FOC per Voyage') + ' *'}
                                onlyFloat={true}
                              ></FormTextField>
                            </Stack>
                            <Stack sx={{ width: '16px' }} />
                            <Stack flex={1}>
                              <Typography
                                className="fw-regular ff-Roboto fs-12"
                                color={text}
                              >
                                {t('Total CO2')}
                              </Typography>
                              <Typography
                                className="fw-regular ff-Roboto fs-12 !capitalize"
                                color={textLight}
                              >
                                ({t('Estimated FOC')} * {t('Emission Factor')})
                              </Typography>
                              <Typography
                                className="fw-regular ff-medium fs-16"
                                color={text}
                              >
                                {(parseFloat(data?.estFuelConsumption || 0) * data?.emissionFactor).toFixed(2)}
                              </Typography>
                            </Stack>
                          </Stack>
                          {/* <Stack
                            style={{ backgroundColor: '#14285A1A', width: '100%', height: '1px' }}
                            className="!my-[12px] !mr-[16px]"
                          /> */}
                        </Stack>
                      ))}
                    </>
                  )}
                />
                {/* {values?.fuelUsed?.length > 0 && (
                  <Stack
                    direction={'row'}
                    alignItems={'center'}
                    justifyContent={'space-between'}
                  >
                    <Typography
                      className="fw-medium ff-Roboto fs-14"
                      color={text}
                    >
                      {t('Estimated total EUA cost')}
                    </Typography>
                    <Typography
                      className="fw-bold ff-Roboto fs-14 "
                      color={text}
                    >
                      € {values?.fuelUsed[values?.fuelUsed?.length - 1].emissionFactor ? getTotal(values.fuelUsed) : ''}
                    </Typography>
                  </Stack>
                )} */}
              </Stack>

              <DialogActions
                className="!mt-[44px] h-[66px] !justify-end p-[0px] sticky bottom-[0]"
                style={{ backgroundColor: '#FFFFFF', zIndex: 1 }}
              >
                <Button
                  sx={[
                    dialogButtonCancel,
                    {
                      color: theme.palette.primary.main,
                      '&:hover': {
                        // backgroundColor: theme.palette.secondary.main,
                        // color: theme.palette.background.main,
                        // borderColor: theme.palette.secondary.main,
                      },
                    },
                  ]}
                  style={{ width: '128px', marginLeft: '80px', height: '40px' }}
                  onClick={() => {
                    onModelHandleClose(false);
                  }}
                >
                  {t('Close')}
                </Button>
                <Button
                  sx={[
                    buttonStyle2,
                    {
                      color: theme.palette.background.main,
                      backgroundColor: theme.palette.primary.dark,
                      textTransform:'uppercase',
                      '&:hover': {
                        // backgroundColor: theme.palette.secondary.main,
                        // color: theme.palette.background.main,
                      },
                    },
                  ]}
                  style={{ width: '128px', height: '40px' }}
                  disabled={!(dirty && isValid) || dayjs(values?.fromDate) > dayjs(values?.toDate)}
                  type="submit"
                  variant="contained"
                >
                  {t('Start')}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Stack>
    </Dialog>
  );
}
